// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo__Logo__[hash_base64-5]","LogoSmall":"Logo__LogoSmall__[hash_base64-5]"};